<template lang="pug">
    v-container(fluid)
        h1.text-center Editar Campeonato De Ejemplo
        v-row.pa-10(align="center" justify="center")
          v-col(cols="12")
            v-card(flat raised)
                v-card-text.text--primary
                    v-form(v-model="valid")
                        v-row.pa-10(align="center" justify="center")
                            v-col.d-inline-block(cols="12" md="6" lg="6" sm="6" xs="12")
                                v-text-field( :counter="40" value="Competicion de Ejemplo" label="Nombre" required)
                            v-col.d-inline-block(cols="12" md="6" lg="6" sm="6" xs="12")
                                v-select( :items="Types" :rules="[v => !!v || 'Item is required']" value="Ejemplo"  label="Tipo de Competicion"  required)
                            v-col.d-inline-block(cols="12" md="6" lg="6" sm="6" xs="12")
                                v-select( :items="Matchsets" value="Matchset 1" :rules="[v => !!v || 'Item is required']"  label="Matchset Asociado")
                            v-col.d-inline-block(cols="12" md="6" lg="6" sm="6" xs="12")
                                v-text-field( :counter="6" label="Presupuesto" type="number" required)
                            v-col.d-inline-block(cols="12" md="4" lg="4" sm="12" xs="12")
                                v-btn(color="light-green darken-1") Open
                            v-col.d-inline-block(cols="12" md="4" lg="4" sm="12" xs="12")
                                v-btn(color="red darken-1") Close
                            v-col.d-inline-block(cols="12" md="4" lg="4" sm="12" xs="12")
                                v-btn(color="amber darken-1") Finish
                v-card-actions.py-5.px-5
                  v-spacer(text-right)
                    v-btn.float-right(color="primary") Guardar
</template>

<script>
    export default {
        name: 'FantasyContestsEdit',
        data: () => ({
            valid: false,
            Types:['Type1', "Type2" , "Type3"],
            Matchsets:['Matchset1', "Matchset2" , "Matchset3"]
        }),
    }
</script>

<style scoped>
    .v-content >>> .v-btn--absolute{
       z-index:2;
    }
</style>